module.exports = __webpack_public_path__ + "static/img/k5.17c93d30.png";